'use client';
import React, { ComponentProps } from 'react';

import Link from 'next/link';

import { ArrowUpRight } from 'lucide-react';

import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import { DataLayerFeature } from '@/modules/product/services/data-layer-events/add-to-wishlist';
import { selectContentDataLayerEvent } from '@/modules/product/services/data-layer-events/select_content';

interface BlogPostFieldsFragment extends ComponentProps<'div'> {
  shopLinks?: (string | null)[] | null | undefined;
}

export default function BlogPostLinks({ shopLinks }: BlogPostFieldsFragment) {
  return (
    <ul className="mt-8 grid gap-3">
      {shopLinks?.map((link) =>
        link ?
          <Link
            key={link}
            href={`/search?query=${link}`}
            onClick={() => {
              selectContentDataLayerEvent({
                contentId: `shop-${link.toLowerCase().split(' ').join('-')}`,
                contentType: 'Quick link',
                feature: DataLayerFeature.Blog,
                name: `Shop ${link}`,
                where: DataLayerWhere.Recommendations,
              });
            }}
            className="flex items-center gap-1 font-bold transition-opacity hover:opacity-60"
          >
            Shop {link} <ArrowUpRight strokeWidth={1} className="font-thin" />
          </Link>
        : null
      )}
    </ul>
  );
}
